import { ArrowForward } from '@material-ui/icons'
import React from 'react'
import styled from 'styled-components'

import { H2, H3 } from '../Typography/Typography'
import Link from '../atoms/link'
import theme from '../atoms/theme'

const { colours, icon, animation, breakpoints } = theme

export const PageCategoryGroupContentSetContainer = styled.div`
  margin-bottom: 3.4rem;
`

export const ArrowForwardStyled = styled(ArrowForward)`
  position: absolute;
  top: 2.2rem;
  right: 1.6rem;
  transform: translate3d(-1rem, 0, 0);
  transition: transform ${animation.defaultLength} ease-in-out;

  &.MuiSvgIcon-root {
    width: ${icon.smallSize};
    height: ${icon.smallSize};
  }
`

const H3Styled = styled(H3)`
  margin-bottom: 1.6rem;
`

const PageCategoryGroupItem = styled(Link).attrs(() => ({
  'data-sal': 'slide-up',
  'data-sal-duration': '1000',
}))`
  margin-bottom: 2.5rem;
  background-color: ${colours.light};
  padding: 1.6rem;
  text-decoration: none;
  position: relative;

  @media only screen and ${breakpoints.fromNormalScreen} {
    width: calc(1 / 3 * 100% - (1 - 1 / 3) * 2.5rem);
    margin-right: 2.5rem;
  }

  &:nth-child(3n) {
    margin-right: 0;
  }

  &:hover {
    ${ArrowForwardStyled} {
      transform: translate3d(0, 0, 0);
    }

    ${H3Styled} {
      color: ${colours.primary};
    }
  }

  ${ArrowForwardStyled} {
    transition: transform ${animation.defaultLength} ease-in-out;
  }

  ${H3Styled} {
    font-weight: 700;
    text-transform: uppercase;
    transition: color ${animation.defaultLength} ease-in-out;
  }
`

const PageCategoryGroupContentSetWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media only screen and ${breakpoints.toNormalScreen} {
    flex-direction: column;
  }
`

const LeadingParagraph = styled.div`
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;
`

type PageCategoryGroupContentSetPropTypes = {
  title: string
  nodes: [Queries.ContentfulPage]
  hideTitle: boolean
}

const PageCategoryGroupContentSet = (
  props: PageCategoryGroupContentSetPropTypes,
): JSX.Element => {
  const { title, hideTitle, nodes } = props

  return (
    <PageCategoryGroupContentSetContainer>
      {hideTitle === true ? null : <H2>{title}</H2>}
      <PageCategoryGroupContentSetWrapper>
        {nodes.map((link) => {
          const { category } = link
          const categorySlug = category
            ? `${category.pageCategoryParent ? `${category.pageCategoryParent.slug}/${category.slug}` : category.slug}`
            : null
          const computedSlug = categorySlug
            ? `${categorySlug}/${link.slug}`
            : link.slug

          return (
            <PageCategoryGroupItem
              to={link.url ? link.url : `/${computedSlug}/`}
              key={`${link.url}-${link.title}`}
            >
              <ArrowForwardStyled />
              <H3Styled>{link.title}</H3Styled>
              {link.leadingParagraph && (
                <LeadingParagraph>
                  {link.leadingParagraph.childMarkdownRemark.rawMarkdownBody}
                </LeadingParagraph>
              )}
            </PageCategoryGroupItem>
          )
        })}
      </PageCategoryGroupContentSetWrapper>
    </PageCategoryGroupContentSetContainer>
  )
}

export default PageCategoryGroupContentSet
